import { env } from "@acme/env/client";
import { createAuthClient } from "better-auth/react";
import { lastLoginMethodClient } from "better-auth/client/plugins";

//TODO: test commit line change
//TODO: test commit line change

export const authClient = createAuthClient({
  baseURL: env.PUBLIC_BACKEND_URL,
  plugins: [lastLoginMethodClient()],
  fetchOptions: {
    credentials: "include",
    // onSuccess(ctx)
    // {
    //   console.log(ctx);
    // },
    // onError(ctx)
    // {
    //   console.log("error while executed better-auth fetch!");
    //   console.error(ctx);
    // },
  },
});
